import { createSlice } from "@reduxjs/toolkit";
import { appReducers } from "./appReducers";

const initialState = {
  showPoultries: false,
  showStewards: false,
  showLiveStocks: false,
  showInspections: false,
  activeLayer: null,
  mapAttribution:
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  mapUrl: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  mapViewIndex: null,
  searchMarker: "",

  pending: false,
  inActiveTime: 1800,
  modal: {
    modalState: false,
    modalContent: null,
    modalTitle: null,
    modalOnClose: null,
  },
  drawer: {
    top: false,
    left: false,
    bottom: false,
    right: false,
    content: null,
    title: null,
  },
};

const slice = createSlice({
  name: "app",
  initialState,
  reducers: appReducers,
  extraReducers: {},
});

export const { reducer: appSlice } = slice;

export const {
  LOADING_START,
  LOADING_END,
  CLOSE_MODAL,
  OPEN_MODAL,
  DRAWER,
  BACKDROP_SHOW,
  BACKDROP_HIDE,
  RESET_TIME_TO_LOGOUT,
  SET_SHOW_STEWARDS,
  SET_SHOW_POULTRIES,
  SET_MAP_VIEW,
  SET_SEARCH_MARKER,
  SET_SHOW_LiveStocks,
  SET_SHOW_INSPECTIONS,
  SET_ACTIVE_LAYER,
} = slice.actions;
